import { createFlowNode, NODE_HANDLE_IDS, NODE_TYPES } from '@flow/nodes';

class _PlanStepHelpers {
  findNodeByStepId = (lookForStepId, nodes) => {
    let found = null;
    nodes.forEach((node) => {
      const stepId = node.data?.planStepData?.step_id;
      if (stepId === lookForStepId) {
        found = node;
      }
    });
    return found;
  };

  generateNode = (data, i) => {
    const node = createFlowNode(NODE_TYPES.PlanStepNode);
    node.data = { ...node.data, ...data };
    node.position = PlanStepHelpers.generateNodePosition(i);
    return node;
  };

  generateNodePosition = (i) => {
    const initialHorizontalSeparation = 1100;
    const verticalNodeSpacing = 300;
    const horizontalNodeSpacing = 620;
    return { x: initialHorizontalSeparation + horizontalNodeSpacing * i, y: verticalNodeSpacing };
  };

  generateEdges = (nodes, startNodeId) => {
    if (nodes.length === 0) return [];

    function buildEdge(sourceId, targetId, overrideSourceHandle, overrideTargetHandle) {
      return {
        id: `xy-${sourceId}${NODE_HANDLE_IDS.planStep}${targetId}${NODE_HANDLE_IDS.planStep}-autogen`,
        type: 'custom',
        source: sourceId,
        sourceHandle: overrideSourceHandle || NODE_HANDLE_IDS.planStep,
        target: targetId,
        targetHandle: overrideTargetHandle || NODE_HANDLE_IDS.planStep,
      };
    }

    const edges = [];
    const firstEdge = buildEdge(startNodeId, nodes[0].id);
    edges.push(firstEdge);

    nodes.forEach((node) => {
      const planStepData = node.data.planStepData;
      const { next_step_ids, conditional_next_step_ids } = planStepData;
      console.log('processing edge', planStepData, node, nodes);

      if (next_step_ids) {
        const nextStepNode = this.findNodeByStepId(next_step_ids[0], nodes);
        if (nextStepNode) {
          edges.push(buildEdge(node.id, nextStepNode.id));
        }
      }
      if (conditional_next_step_ids) {
        const yesNextStepIds = conditional_next_step_ids.Yes;
        const noNextStepIds = conditional_next_step_ids.No;

        yesNextStepIds?.forEach((conditionalNextStepId) => {
          const conditionalNextStepNode = this.findNodeByStepId(conditionalNextStepId, nodes);
          if (conditionalNextStepNode) {
            edges.push(buildEdge(node.id, conditionalNextStepNode.id, NODE_HANDLE_IDS.planStepYes));
          }
        });
        noNextStepIds?.forEach((conditionalNextStepId) => {
          const conditionalNextStepNode = this.findNodeByStepId(conditionalNextStepId, nodes);
          if (conditionalNextStepNode) {
            edges.push(buildEdge(node.id, conditionalNextStepNode.id, NODE_HANDLE_IDS.planStepNo));
          }
        });
      }
    });
    return edges;
  };
}

export const PlanStepHelpers = new _PlanStepHelpers();
